import {
  Description,
  Label,
  ListCheckbox,
  ListImage,
  NameDescription,
  OptionsListContainer,
  Overlay,
  ProductOptionsRow,
  TitleContainer
} from './OptionsList.styles'
import { IOptionsListProps } from './OptionsList.types'

const OptionsList = ({
  options,
  onOptionChange,
  imageProps
}: IOptionsListProps) => {
  return (
    <OptionsListContainer>
      {options.map((option) => {
        const {
          id,
          namesDescriptions,
          isChecked,
          imageUrl = '',
          disabled = false
        } = option
        const areManyNamesDescriptions = namesDescriptions.length > 1
        return (
          <ProductOptionsRow key={id}>
            {disabled && <Overlay />}
            <ListImage
              src={imageUrl}
              alignBaseLine={areManyNamesDescriptions}
              {...imageProps}
            />
            <TitleContainer>
              {namesDescriptions.map(({ name, description }) => (
                <NameDescription
                  directionRow={areManyNamesDescriptions}
                  key={name}>
                  <Label lines={1}>{name}</Label>
                  <Description lines={1}>{description}</Description>
                </NameDescription>
              ))}
            </TitleContainer>
            <ListCheckbox
              disabled={disabled}
              onChange={(_e, checked) => {
                onOptionChange({ option, checked })
              }}
              name={id}
              checked={isChecked}
            />
          </ProductOptionsRow>
        )
      })}
    </OptionsListContainer>
  )
}

export default OptionsList
